export default __webpack_public_path__ + "static/media/htbabyImg3.e10bd02e.png";